export function newAbortSignal(timeoutMs: number) {
    const abortControler = new AbortController();
    setTimeout(() => abortControler.abort(), timeoutMs || 0);
    return abortControler.signal;
}